export type UserRole = 'admin' | 'user' | 'developer' | 'tester';

export interface AdminUser {
	id: number;
	username: string;
	email: string;
	role: UserRole;
	is_active: boolean;
	last_active: string | null;
	date_joined: string;
}

export interface UserProfile {
	id: number;
	username: string;
	email: string;
	user_role: UserRole;
	accessible_projects: {
		id: number;
		name: string;
		role: string;
	}[];
}

export interface LoginEvent {
	id: number;
	created_at: string;
	ip_address: string;
	device: string;
	browser: string;
	os: string;
	city: string;
	region: string;
	country: string;
	country_code: string;
}

export interface CreateUserRequest {
	username: string;
	email?: string;
	password: string;
	role: UserRole;
}

export interface UpdateUserRequest {
	email?: string;
	password?: string;
	role?: UserRole;
	is_active?: boolean;
}

export const USER_ROLE_LABELS: Record<UserRole, string> = {
	admin: 'Admin',
	user: 'Designer / Programmer',
	developer: 'Developer',
	tester: 'Testing Engineer'
};
